import { HTMLAttributes } from 'react'

import { cn, VStack } from '@podo-app/design-system-temp'

export const PageContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <VStack className={cn('flex-1 p-5 justify-center w-full', className)} {...props}>
      {props.children}
    </VStack>
  )
}

export const PageContentView = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <VStack className={cn('flex-1 w-full', className)} {...props}>
      {props.children}
    </VStack>
  )
}
